"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseStyle = exports.DefaultTheme = void 0;
exports.rgba = rgba;
exports.assetURL = assetURL;
exports.assetPath = assetPath;
exports.addStyles = addStyles;
exports.attachSheet = attachSheet;
const tslib_1 = require("tslib");
const jss_1 = tslib_1.__importDefault(require("jss"));
const jss_preset_default_1 = tslib_1.__importDefault(require("jss-preset-default"));
const theme_palette_1 = require("./theme.palette");
// Use the internal rule names for all classNames
const createGenerateClassName = () => rule => rule.key;
const options = (0, jss_preset_default_1.default)();
options.createGenerateClassName = createGenerateClassName;
jss_1.default.setup(options);
function rgba(color, alpha) {
    if (alpha == null) {
        return `rgb(${color})`;
    }
    return `rgba(${color}, ${alpha})`;
}
function assetURL(path) {
    return `url(${assetPath(path)})`;
}
function assetPath(path) {
    const version = window.IKE_APPLICATION_VERSION;
    return `${version}${path}`;
}
exports.DefaultTheme = {
    space: amount => exports.DefaultTheme.spacingFactor * amount + 'px',
    spacingFactor: 4,
    color: {
        primary: rgba(theme_palette_1.ColorPaletteBlue.C700),
        primaryDark: rgba(theme_palette_1.ColorPaletteBlue.C900),
        accent: theme_palette_1.ColorPalette2022Branding.ikeOrange,
        accentDark: rgba(theme_palette_1.ColorPaletteOrange.C900),
        lightIndigo: theme_palette_1.ColorPalette2022Branding.lightIndigo
    },
    background: {
        darkGrey: theme_palette_1.ColorPalette2022Branding.darkGray,
        mediumGrey: '#3C404D',
        offWhite: '#fafafa',
        grey: rgba(theme_palette_1.ColorPaletteGrey.C100),
        lightGrey: rgba(theme_palette_1.BLACK, 0.06),
        active: rgba(theme_palette_1.BLACK, 0.12),
        fadedGrey: '#b8b8b8'
    },
    font: {
        size: 14,
        family: 'Roboto, sans-serif',
        familyCondensed: 'Roboto Condensed',
        weight: {
            normal: 400,
            bold: 700
        },
        color: {
            white: rgba(theme_palette_1.WHITE, 0.87),
            primary: '#000000',
            supporting: rgba(theme_palette_1.BLACK, 0.54),
            disabled: rgba(theme_palette_1.BLACK, 0.26),
            divider: rgba(theme_palette_1.BLACK, 0.12),
            hover: rgba(theme_palette_1.BLACK, 0.20),
            link: rgba(theme_palette_1.ColorPaletteOrange.C700, 0.87),
            error: rgba(theme_palette_1.ColorPaletteRed.A700),
            insight: '#fff'
        }
    },
    shadow: {
        box: {
            bottom: '-2px 4px 2px -3px rgba(0, 0, 0, .14)',
            dp2: '0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12)',
            dp2w5: '0 0 0 5px rgba(0,0,0,.12), 0 0 0 5px rgba(0,0,0,.24)',
            dp4: '0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12), 0 2px 4px -1px rgba(0, 0, 0, .2)',
            dp6: '0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12), 0 3px 5px -1px rgba(0, 0, 0, .2)'
        },
        text: `0 1px 1px ${rgba(theme_palette_1.BLACK, 0.54)}`
    }
};
exports.BaseStyle = {
    '@global': {
        a: {
            color: exports.DefaultTheme.color.accent,
            'font-weight': 500,
            'text-decoration': 'none',
            cursor: 'pointer'
        }
    },
    'mdl-button--accent.mdl-button--accent.mdl-button--fab, .mdl-button--accent.mdl-button--accent.mdl-button--raised': {
        color: theme_palette_1.WHITE,
        'background-color': exports.DefaultTheme.color.accent
    },
    'mdl-button--accent.mdl-button--accent': {
        color: exports.DefaultTheme.color.accent
    },
    'mdl-button--raised.mdl-button--disabled.mdl-button--disabled, .mdl-button--raised[disabled][disabled]': {
        'background-color': exports.DefaultTheme.font.color.divider,
        color: exports.DefaultTheme.font.color.disabled,
        'box-shadow': 'none'
    },
    '@media print': {
        body: {
            background: 'transparent !important'
        },
        '*': {
            color: '#000 !important',
            'box-shadow': 'none !important',
            'text-shadow': 'none !important'
        }
    }
};
const baseSheet = jss_1.default.createStyleSheet(exports.BaseStyle);
function addStyles(style) {
    baseSheet.addRules(style);
}
function attachSheet() {
    baseSheet.attach();
}
//# sourceMappingURL=theme.js.map